import decode from 'jwt-decode';
import axios from 'axios';
export default class AuthService {

    constructor(domain) {
        this.domain = domain || 'https://api.happyquest.co/';
        this.httpRequest = this.httpRequest.bind(this);
        this.login = this.login.bind(this);
        this.getProfile = this.getProfile.bind(this);
    }

    login(username, password) {
        return this.httpRequest('post', 'auth/login', {email:username, password:password})
            .then(this._checkStatus)
            .then(res => {
                this.setToken(res.data.token)
                return Promise.resolve(res.data);
            })
    }

    loggedIn() {
        const token = this.getToken()
        return !!token && !this.isTokenExpired(token)
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) {
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    setToken(idToken) {
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        return localStorage.getItem('id_token')
    }

    logout() {
        localStorage.removeItem('id_token');
    }

    getProfile() {
        return decode(this.getToken());
    }


    httpRequest(method, url, body = null) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return axios(this.domain + url, {
            method: method,
            headers: headers,
            data: body
        });
    }

    _checkStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/AuthService.js